
import './roomCard.scss';
import { Box, Tooltip, Typography } from '@mui/material';
import { IReservation, IRoom } from '../../interfaces/IPartnerPms';
import { GovernanceStatusData, OccupancyStatusData, RoomStatusData } from '../../data/Enums';
import { useMemo } from 'react';
import { useLanguageContext } from '../../contexts/LanguageContext';


interface IRoomCardProps {
    room: IRoom;
    showGovernanceTooltip?: boolean;
    onClick?: () => void;
    className?: string;
}


const RoomCard: React.FC<IRoomCardProps> = ({
    room,
    showGovernanceTooltip = false,
    onClick = () => {},
    className = ''
}) => {
    const { translate } = useLanguageContext();


    const occupancy = useMemo(() => {
        return Object.values(OccupancyStatusData).find(s => s.partnerId === room.occupancyStatusId);
    }, [room]);

    
    const governance = useMemo(() => {
        return Object.values(GovernanceStatusData).find(s => s.partnerId === room.governanceStatusId);
    }, [room]);


    const governanceIcon = useMemo(() => {
        if (governance) {
            const governanceIcon = <governance.Icon className='icon-governance' sx={{ backgroundColor: `${governance.color} !important` }} />;

            if (showGovernanceTooltip) {
                return <Tooltip title={translate(governance.name)} placement="left" arrow disableInteractive>
                    {governanceIcon}
                </Tooltip>;
            } else {
                return governanceIcon;
            }
        }

        return null;
    }, [governance, showGovernanceTooltip, translate]);

    
    return (
        <Box 
            onClick={onClick}
            className={`partnerpms-roomcard ${className}`}
            sx={{
                backgroundColor: `${occupancy?.color} !important`
            }}
        >
            <Box className='box-room'>
                <Typography variant='subtitle1' className='text-title'> {room.description} </Typography>

                <Box className='box-governance'>
                    {governanceIcon}
                </Box>
            </Box>
                
            <Box className='box-reservation'>
                {
                    Object.values(RoomStatusData).map(s => {
                        const roomKey = (s.partnerId ?? '') as keyof(IRoom);
                        const reservationKey = (s.partnerId ?? '') as keyof(IReservation);

                        if (room[roomKey] === true || (room.checkInReservation && room.checkInReservation[reservationKey] === true)) {
                            return <s.Icon className='icon-reservation' sx={{ backgroundColor: `${s.color} !important` }} />;
                        }

                        return null;
                    })
                }
            </Box>
        </Box>
    );
}

export default RoomCard;